import { ComputedValueGetter } from "../../../../utils/ComputedValueGetter.js";

/**
 * Uses media queries to get the primary hover type ("hover" | "none" | null).
 *
 * `hover` means the pointer can hover
 *
 * `none` means the device cannot hover
 *
 * `null` means an error was encountered or nothing was matched
 **/
export function getDevicePrimaryHoverType ()
{
  try
  {
    if (window.matchMedia("only screen and (hover: hover)").matches)
    {
      return "hover" as const;
    }
    else if (window.matchMedia("only screen and (hover: none)").matches)
    {
      return "none" as const;
    }
  }
  // eslint-disable-next-line no-empty
  catch { }
  return null;
}

export const DevicePrimaryHoverType = new ComputedValueGetter({
  isLazy: true,
  computeFn: getDevicePrimaryHoverType
});